export const privacy = {
  backToHome: "Retour à l'accueil",
  title: "Politique de Confidentialité",
  lastUpdated: "Dernière mise à jour:",
  sections: {
    introduction: {
      title: "1. Introduction",
      content: "NovaVenture Group BV (ci-après : 'NovaVenture', 'nous' ou 'notre') respecte votre vie privée et s'engage à protéger les données personnelles conformément au Règlement Général sur la Protection des Données (RGPD) et à la législation belge. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons les données d'entreprise dans le cadre de nos activités B2B."
    },
    company: {
      title: "2. Responsable du Traitement des Données",
      content: "NovaVenture Group BV",
      address: "Krommestraat 48, 2830 Blaasveld, Belgique",
      vat: "Numéro de TVA: BE1006303437",
      enterprise: "Numéro d'entreprise: 1006303437",
      email: "E-mail: David@novaventure.be",
      phone: "Téléphone: +32 488 13 96 64"
    },
    dataCollection: {
      title: "3. Quelles Données Traitons-Nous?",
      intro: "NovaVenture traite exclusivement des données d'entreprise accessibles au public. Nous ne traitons PAS de données personnelles de personnes physiques, telles que les noms d'individus, les adresses e-mail personnelles ou d'autres données personnelles sensibles.",
      subtitle: "Les données d'entreprise suivantes sont traitées:",
      items: {
        company: "Nom de l'entreprise (raison sociale officielle)",
        phone: "Numéro de téléphone fixe de l'entreprise",
        address: "Adresse complète de l'entreprise (rue, numéro, code postal, commune)",
        vat: "Numéro de TVA de l'entreprise"
      },
      note: "Ces données concernent exclusivement des personnes morales (entreprises) et non des personnes physiques dans un contexte privé."
    },
    dataSource: {
      title: "4. Origine des Données",
      content: "Toutes les données d'entreprise sont collectées à partir de sources en ligne accessibles au public où les entreprises ont elles-mêmes publié leurs informations, telles que:",
      sources: [
        "Registres officiels des entreprises et du commerce",
        "Sites web publics des entreprises",
        "Annuaires d'entreprises publics",
        "Autres sources légales et accessibles au public"
      ],
      note: "Nous n'achetons pas de bases de données privées et ne traitons pas de données provenant de sources non publiques."
    },
    dataUsage: {
      title: "5. Finalités du Traitement des Données",
      intro: "Nous traitons les données d'entreprise aux fins suivantes:",
      items: [
        "Prospection B2B et génération de leads commerciaux",
        "Vente commerciale de données d'entreprise à des clients professionnels",
        "Fourniture d'informations de marché commerciales",
        "Soutien aux activités commerciales légitimes de nos clients"
      ]
    },
    legalBasis: {
      title: "6. Base Juridique",
      intro: "Le traitement des données d'entreprise est fondé sur l'article 6, paragraphe 1, point f) du RGPD: intérêt légitime.",
      content: "NovaVenture a un intérêt légitime à collecter et fournir des données d'entreprise accessibles au public pour des activités B2B légitimes. Nous avons effectué une mise en balance minutieuse des intérêts:",
      balancing: {
        title: "Mise en balance des intérêts:",
        business: "Intérêt commercial: Faciliter une communication B2B efficace et le fonctionnement du marché",
        privacy: "Impact sur la vie privée: Minimal, car seules les données d'entreprise accessibles au public de personnes morales sont traitées",
        noPersonal: "Aucun traitement de données personnelles de personnes physiques dans un contexte privé",
        objection: "Les entreprises ont le droit de s'opposer à tout moment à leur inclusion dans notre base de données"
      }
    },
    retention: {
      title: "7. Durée de Conservation",
      content: "Les données d'entreprise ne sont pas conservées plus longtemps que nécessaire aux fins pour lesquelles elles ont été collectées. Nous effectuons des contrôles périodiques pour garantir l'exactitude et la pertinence des données. Les données obsolètes ou incorrectes sont supprimées ou mises à jour."
    },
    dataSharing: {
      title: "8. Communication à des Tiers",
      intro: "Les données d'entreprise sont communiquées à:",
      items: [
        "Des clients professionnels qui utilisent les données pour une prospection B2B légitime",
        "Des prestataires de services qui nous soutiennent (par ex. hébergement, sécurité informatique), sous des obligations strictes de confidentialité"
      ],
      euOnly: "Nous ne traitons pas de données en dehors de l'Union européenne. Tout traitement de données a lieu au sein de l'UE/EEE."
    },
    yourRights: {
      title: "9. Vos Droits en Tant que Personne Concernée",
      intro: "Si votre entreprise est incluse dans notre base de données, vous disposez des droits suivants:",
      items: {
        access: "Droit d'accès: Vous pouvez demander quelles données d'entreprise nous traitons concernant votre entreprise",
        rectification: "Droit de rectification: Vous pouvez demander la correction de données incorrectes ou obsolètes",
        erasure: "Droit à l'effacement: Vous pouvez demander la suppression des données de votre entreprise",
        restriction: "Droit à la limitation: Vous pouvez demander la limitation du traitement",
        objection: "Droit d'opposition: Vous pouvez vous opposer à tout moment au traitement des données d'entreprise de votre entreprise"
      },
      objectionNote: {
        title: "Droit d'opposition explicite:",
        content: "Les entreprises peuvent s'opposer à tout moment à leur inclusion dans notre base de données. Dès réception de votre opposition, nous supprimerons les données de votre entreprise de nos systèmes, sauf si nous avons des motifs légitimes impérieux démontrables pour le traitement qui prévalent sur vos intérêts."
      },
      howTo: {
        title: "Comment pouvez-vous exercer vos droits?",
        content: "Vous pouvez exercer vos droits en envoyant une demande à:",
        email: "E-mail: David@novaventure.be",
        response: "Nous traiterons votre demande dans un délai de 30 jours et vous informerons des mesures prises."
      }
    },
    dataSecurity: {
      title: "10. Sécurité des Données",
      content: "NovaVenture prend des mesures techniques et organisationnelles appropriées pour protéger les données d'entreprise contre l'accès non autorisé, la perte, l'utilisation abusive, la modification ou la divulgation. Ces mesures comprennent:",
      measures: [
        "Stockage sécurisé et cryptage des données",
        "Contrôle d'accès et authentification",
        "Mises à jour de sécurité et surveillance régulières",
        "Obligations de confidentialité pour les employés et les sous-traitants"
      ]
    },
    complaint: {
      title: "11. Droit de Déposer une Plainte",
      content: "Si vous estimez que nous ne traitons pas correctement vos données, vous avez le droit de déposer une plainte auprès de l'autorité de contrôle belge:",
      authority: "Autorité de Protection des Données (APD)",
      addressLine1: "Drukpersstraat 35, 1000 Bruxelles, Belgique",
      phone: "Téléphone: +32 2 274 48 00",
      email: "E-mail: contact@apd-gba.be",
      website: "Site web: www.autoriteprotectiondonnees.be"
    },
    changes: {
      title: "12. Modifications de Cette Politique de Confidentialité",
      content: "NovaVenture se réserve le droit de modifier cette politique de confidentialité. Les modifications seront publiées sur cette page avec une date mise à jour. Nous vous recommandons de consulter régulièrement cette politique."
    },
    contact: {
      title: "13. Contact",
      intro: "Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, vous pouvez nous contacter:",
      company: "NovaVenture Group BV",
      address: "Krommestraat 48, 2830 Blaasveld, Belgique",
      phone: "Téléphone:",
      email: "E-mail:",
      vat: "TVA: BE1006303437"
    }
  }
};